import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function PrpTherapy() {
  useEffect(() => {
    document.title =
      "PRP and Non-Surgical Pain Relief Options | Viksha Health Care";
    const newMetaDescription =
      "PRP and non-surgical pain relief options at Viksha Health Care. Understand potential benefits, limitations, and who may be suitable.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>
        PRP and Non-Surgical Pain Relief Options
      </h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/PRP-and-Non-Surgical-Pain-Relief-Options.jpg" />
        </div>
        <div className="textareaofser">
          <h1>PRP and Non-Surgical Pain Relief Options</h1>

          <p>
            PRP (Platelet-Rich Plasma) and other non-surgical pain relief
            options are used to manage joint, tendon, and muscle pain without
            surgery. These treatments focus on reducing inflammation, supporting
            healing, and improving function so patients can return to daily
            activities with less discomfort.
          </p>

          <p>
            Non-surgical options are often recommended when pain persists
            despite medications, rest, and physiotherapy, or when patients wish
            to delay or avoid surgery.
          </p>

          <h5>What Is PRP Therapy?</h5>
          <p>
            PRP therapy involves using a concentrated portion of your own blood
            that is rich in platelets. Platelets contain growth factors that may
            help support the body’s natural healing processes in selected
            conditions involving joints, tendons, and soft tissues.
          </p>

          <h5>Conditions That May Benefit</h5>
          <ul>
            <li>Chronic tendon pain</li>
            <li>Joint pain due to early arthritis</li>
            <li>Ligament injuries</li>
            <li>Muscle strains that are slow to heal</li>
            <li>Sports-related overuse injuries</li>
          </ul>

          <h5>Other Non-Surgical Pain Relief Options</h5>
          <ul>
            <li>Targeted joint or soft tissue injections</li>
            <li>Physiotherapy and structured rehabilitation programs</li>
            <li>Bracing or supportive devices</li>
            <li>Lifestyle and activity modifications</li>
            <li>Posture and movement correction techniques</li>
          </ul>

          <h5>Benefits of Non-Surgical Pain Relief</h5>
          <ul>
            <li>Minimally invasive treatment</li>
            <li>Reduced recovery time compared to surgery</li>
            <li>Lower risk compared to major surgical procedures</li>
            <li>Helps delay or avoid surgery in selected cases</li>
            <li>Supports improved movement and daily function</li>
          </ul>

          <h5>What to Expect During PRP Treatment</h5>
          <p>
            The procedure typically involves drawing a small amount of blood,
            processing it to concentrate the platelets, and injecting it into
            the affected area. The treatment is usually performed as an
            outpatient procedure.
          </p>

          <h5>Aftercare and Recovery</h5>
          <p>
            Mild soreness may occur for a short period after treatment. Gradual
            return to normal activities is advised, along with physiotherapy or
            exercises when recommended to enhance recovery.
          </p>

          <h5>How These Treatments Support Healing</h5>
          <p>
            By reducing inflammation and promoting a better healing environment,
            these options may help improve tissue repair and reduce long-term
            pain. They are most effective when combined with rehabilitation and
            lifestyle changes.
          </p>

          <h5>When to Consider Non-Surgical Options</h5>
          <ul>
            <li>Pain that persists despite medication and physiotherapy</li>
            <li>Desire to avoid or delay surgery</li>
            <li>Chronic soft tissue or joint discomfort</li>
            <li>Recurrent flare-ups affecting daily life</li>
          </ul>

          <p>
            PRP and other non-surgical treatments can provide effective pain
            relief and support recovery, helping patients regain confidence in
            movement while maintaining an active lifestyle.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(PrpTherapy);
